import { months, years } from 'v3/common/components/DatePicker/DateRange/utility';
type Header = {
  date: Date;
  changeYear: (year: number) => void;
  changeMonth: (month: number) => void;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
};

const Header = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: Header) => {
  return (
    <div className="container">
      <div className="d-flex justify-content-evenly align-items-center mb-1">
        <button
          className="react-datepicker__icons"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
        >
          {<i className="fa-solid fa-angle-left"></i>}
        </button>

        <select
          className="react-datepicker__month-select"
          value={date.getMonth()}
          onChange={({ target: { value } }) => changeMonth(Number(value))}
        >
          {months.map((month, index) => (
            <option className="react-datepicker__month-option" key={month} value={index}>
              {month}
            </option>
          ))}
        </select>

        <select
          className="react-datepicker__year-select"
          value={date.getFullYear()}
          onChange={({ target: { value } }) => changeYear(Number(value))}
        >
          {years.map((year) => (
            <option className="react-datepicker__year-option" key={year} value={year}>
              {year}
            </option>
          ))}
        </select>

        <button
          className="react-datepicker__icons"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
        >
          {<i className="fa-solid fa-angle-right"></i>}
        </button>
      </div>
    </div>
  );
};

export default Header;
